import React from 'react';
import { Nav } from 'react-bootstrap';
import DashIcon from '../assets/images/D.svg';
import UserIcon from '../assets/images/U.svg';
import BellIcon from '../assets/images/N.svg';
import CatIcon from '../assets/images/Cat.svg';
import ReportsIcon from '../assets/images/R.svg';
import PackageIcon from '../assets/images/Package.svg';
import ContactIcon from '../assets/images/C.svg';
import Menu from '../assets/images/menu-left-alt.svg';
import { NavLink } from 'react-router-dom';

const menuItems = [
  { icon: DashIcon, text: 'Dashboard', path: '/dashboard' },
  { icon: UserIcon, text: 'User Management', path: '/dashboard/usermanagement' },
  { icon: BellIcon, text: 'Notification Management', path: '/dashboard/notifications' },
  { icon: CatIcon, text: 'Category & Background', path: '/dashboard/categories' },
  { icon: ReportsIcon, text: 'Reports', path: '/dashboard/reports' },
  { icon: UserIcon, text: 'Roles & Right', path: '/dashboard/roles' },
  { icon: PackageIcon, text: 'Packages', path: '/dashboard/packages' },
  { icon: ContactIcon, text: 'Contact Us', path: '/dashboard/contactus' },
];

const Sidebar = ({ isToggled, isHovered, onToggle, onHoverChange, onCloseSidebar = () => { } }) => {
  const isExpanded = isToggled || isHovered;

  return (
    <div
      className={`sidebar ${isExpanded ? 'sidebar-expanded' : 'sidebar-collapsed'}`}
      onMouseEnter={() => onHoverChange(true)}
      onMouseLeave={() => onHoverChange(false)}
    >
      <div
        className={`sidebar-toggle-icon ${isExpanded ? 'align-left' : 'align-center'}`}
        onClick={onToggle}>
        {isToggled ? (
          <i className="fa fa-arrow-left white-icon"></i>
        ) : (
          <img src={Menu} alt="" className='white-icon' />
        )}
      </div>
      <Nav className="flex-column icon-nav">
        {menuItems.map((item, index) => (
          <Nav.Link
            key={index}
            as={NavLink}
            to={item.path}
            end={item.path === '/dashboard'}
            onClick={onCloseSidebar} // for sidebar close in mobile when click on navigation.
          >
            <div className="icon-text-wrapper">
              <img src={item.icon} alt={item.text} className='sideImg' />
              {isExpanded && <span className="sidebar-label">{item.text}</span>}
            </div>
          </Nav.Link>
        ))}
      </Nav>
    </div>
  );
};

export default Sidebar;
